import { Star } from "lucide-react";
import { BUSINESS } from "@/lib/business";
import { trackEvent } from "@/lib/analytics";

/**
 * One honest line about the public Google rating with a link to the profile.
 * No quoted reviews and no review markup (Ashraf's decision, 24 September 2026).
 * The numbers live in src/lib/business.ts and are refreshed by hand.
 */
const GoogleRating = () => {
  const { value, count, asOf } = BUSINESS.googleRating;
  return (
    <section aria-label="Google-Bewertungen" className="py-8 border-y border-border/50 bg-muted/10">
      <div className="container-custom flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2 text-center">
        <span className="flex items-center gap-1 text-primary" aria-hidden="true">
          {Array.from({ length: 5 }, (_, i) => (
            <Star key={i} className="h-4 w-4 fill-current" />
          ))}
        </span>
        <p className="text-sm md:text-base">
          <span className="font-semibold">{value} auf Google</span>
          <span className="text-muted-foreground">
            {" "}
            · {count} Bewertungen · Stand {asOf}
          </span>
        </p>
        <a
          href={BUSINESS.profiles.google}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent("google_reviews_click")}
          className="text-sm font-medium text-primary underline-offset-4 hover:underline"
        >
          Alle Bewertungen auf Google
        </a>
      </div>
    </section>
  );
};

export default GoogleRating;
